
const PrivilegiosEnum = {

    NAO_NECESSITA_PERMISSAO: 'NAO_NECESSITA_PERMISSAO',

    GERENCIAR_AUTORIZACAO: 'GERENCIAR_AUTORIZACAO',
    GERENCIAR_PROCESSO: 'GERENCIAR_PROCESSO',
    GERENCIAR_APROVACAO: 'GERENCIAR_APROVACAO',
    GERENCIAR_PATRIMONIO: 'GERENCIAR_PATRIMONIO',
    GERENCIAR_ALMOXARIFADO: 'GERENCIAR_ALMOXARIFADO',
    GERENCIAR_DEPOSITO: 'GERENCIAR_DEPOSITO',
    GERENCIAR_PARECER_SOLICITACAO_MOVIMENTACAO: 'GERENCIAR_PARECER_SOLICITACAO_MOVIMENTACAO',
    GERENCIAR_PARECER_TRANSFERENCIA_RESPONSABILIDADE: 'GERENCIAR_PARECER_TRANSFERENCIA_RESPONSABILIDADE',
    DAR_PARECER: 'DAR_PARECER',
    INVENTARIAR: 'INVENTARIAR',

    //cadastros essenciais - 'cadastros_essenciais<>' eh a entidade que o menu pertence
    CAD_ESSENC_INCLUIR: 'cadastros_essenciais<>incluir',
    CAD_ESSENC_EDITAR: 'cadastros_essenciais<>editar',
    CAD_ESSENC_ACESSAR: 'cadastros_essenciais<>acessar',
    CAD_ESSENC_EXCLUIR: 'cadastros_essenciais<>excluir',

    CAD_ESSENC_ALMOXARIFADO_INCLUIR: 'cadastros_essenciais_almoxarifado<>incluir',
    CAD_ESSENC_ALMOXARIFADO_EDITAR: 'cadastros_essenciais_almoxarifado<>editar',
    CAD_ESSENC_ALMOXARIFADO_ACESSAR: 'cadastros_essenciais_almoxarifado<>acessar',
    CAD_ESSENC_ALMOXARIFADO_EXCLUIR: 'cadastros_essenciais_almoxarifado<>excluir',

    CAD_ESSENC_PATRIMONIO_INCLUIR: 'cadastros_essenciais_patrimonio<>incluir',
    CAD_ESSENC_PATRIMONIO_EDITAR: 'cadastros_essenciais_patrimonio<>editar',
    CAD_ESSENC_PATRIMONIO_ACESSAR: 'cadastros_essenciais_patrimonio<>acessar',
    CAD_ESSENC_PATRIMONIO_EXCLUIR: 'cadastros_essenciais_patrimonio<>excluir',

    CAD_ESSENC_INCLUIR_FOTO_PRODUTO: 'cadastros_essenciais<>incluir_foto',
    CAD_ESSENC_EDITAR_FOTO_PRODUTO: 'cadastros_essenciais<>editar_foto',
    CAD_ESSENC_ACESSAR_FOTO_PRODUTO: 'cadastros_essenciais<>acessar_foto',
    CAD_ESSENC_EXCLUIR_FOTO_PRODUTO: 'cadastros_essenciais<>excluir_foto',

    CAD_ESSENC_ALTERAR_CLASSE_PRODUTO: 'cadastros_essenciais<>alterar_classe_produto',
    CAD_ESSENC_ASSOCIAR_AU_SUBGRUPO: 'cadastros_essenciais<>associar_ua_subgrupo',

    //itens_consumidos
    ITENS_CONSUMIDOS_ACESSAR: 'itens_consumidos<>acessar',
    ITENS_CONSUMIDOS_VISUALIZAR_SALDO: 'itens_consumidos<>visualizar_saldo',
    ITENS_CONSUMIDOS_SELECIONAR_OUTRA_UA: 'itens_consumidos<>selecionar_outra_ua',

    //ponto de ressuprimento
    PONTO_RESSUPRIMENTO_ACESSAR: 'ponto_ressuprimento<>acessar',

    //devolucao
    DEVOLUCAO_ACESSAR: 'devolucao<>acessar',
    DEVOLUCAO_RECEBER: 'devolucao<>receber',
    DEVOLUCAO_APROVAR: 'devolucao<>aprovar',

    //empenho
    EMPENHO_ACESSAR: 'empenho<>acessar',
    EMPENHO_INCLUIR: 'empenho<>incluir',
    EMPENHO_EXCLUIR: 'empenho<>excluir',
    EMPENHO_CONCLUIR: 'empenho<>concluir',
    EMPENHO_REABRIR: 'empenho<>reabrir',
    EMPENHO_EDITAR: 'empenho<>editar',

    //recebimento oficio/autorizacao/processo
    RECEBIMENTO_RECEBE_OFICIO: 'recebimento<>recebe_oficio',
    RECEBIMENTO_RECEBE_AUTORIZACAO: 'recebimento<>recebe_autorizacao',
    RECEBIMENTO_RECEBE_PROCESSO: 'recebimento<>recebe_processo',

    //Departamento
    DEPARTAMENTO_SINCRONIZAR: 'departamento<>sincronizar',
    DEPARTAMENTO_ACESSAR: 'departamento<>acessar',
    DEPARTAMENTO_MODULO_ACESSAR: 'departamento<>acessar_modulo',
    DEPARTAMENTO_MODULO_EDITAR: 'departamento<>editar_modulo',

    //Perfil
    PERFIL_INCLUIR: 'perfil<>incluir',
    PERFIL_EDITAR: 'perfil<>editar',
    PERFIL_ACESSAR: 'perfil<>acessar',
    PERFIL_LIBERAR: 'perfil<>liberar',

    //Sistema
    SISTEMA_INCLUIR: 'sistema<>incluir',
    SISTEMA_EDITAR: 'sistema<>editar',
    SISTEMA_ACESSAR: 'sistema<>acessar',

    //Usuario
    USUARIO_SINCRONIZAR: 'usuario<>sincronizar',
    USUARIO_ACESSAR: 'usuario<>acessar',

    //Coletor RFID
    COLETOR_RFID_OPERAR: 'coletor<>coletor_rfid_operar',

    //Auditoria
    AUDITORIA_USUARIO_ACESSAR: 'auditoria<>acessar_usuario',
    AUDITORIA_SISTEMA_ACESSAR: 'auditoria<>acessar_sistema',
    AUDITORIA_PRIVILEGIOS_PERFIL_ACESSAR: 'auditoria<>acessar_privilegios_perfil',
    AUDITORIA_PERFIL_USUARIO_ACESSAR: 'auditoria<>acessar_perfil_usuario',
    AUDITORIA_PERFIL_ACESSAR: 'auditoria<>acessar_perfil',
    AUDITORIA_DEPARTAMENTO_ACESSAR: 'auditoria<>acessar_departamento',
    AUDITORIA_DEPARTAMENTO_MODULO_ACESSAR: 'auditoria<>acessar_departamento_modulo',

    //Licencas
    LICENCAS_SINCRONIZAR: 'licencas<>importar',
    LICENCAS_ACESSAR: 'licencas<>acessar',
    LICENCAS_IMPORTAR: 'licencas<>importar',
    LICENCAS_INCLUIR: 'licencas<>incluir',

    //Perfil do Usuario
    PERFIL_USUARIO_INCLUIR: 'perfil_do_usuario<>incluir',
    PERFIL_USUARIO_EDITAR: 'perfil_do_usuario<>editar',
    PERFIL_USUARIO_ACESSAR: 'perfil_do_usuario<>acessar',
    PERFIL_USUARIO_EXCLUIR: 'perfil_do_usuario<>excluir',

    PERFIL_USUARIO_INCLUIR_FILTROS_PESQUISA: 'perfil_do_usuario<>incluir_filtros_pesquisa',

    //Privilégios do Perfil
    PRIVILEGIOS_DO_PERFIL_ACESSAR: 'privilegios_do_perfil<>acessar',

    //relatorio
    RELATORIO_ACESSAR: 'relatorio<>acessar',
    RELATORIO_ACESSAR_ALMOXARIFADO: 'relatorio<>acessar_almoxarifado',
    RELATORIO_ACESSAR_PATRIMONIO: 'relatorio<>acessar_patrimonio',
    RELATORIO_GERAR_BENS_PATRIMONIAIS: 'relatorio<>gerar_bens_patrimoniais',
    RELATORIO_GERAR_BAIXA_ITEM_BEM_CONSUMO: 'relatorio<>gerar_baixa_item_bem_consumo',
    RELATORIO_GERAR_BAIXA_ITEM_BEM_PERMANENTE: 'relatorio<>gerar_baixa_item_bem_permanente',
    RELATORIO_GERAR_BAIXADO_ITEM_BEM_PERMANENTE: 'relatorio<>baixa_ibp_bem_permanente',
    RELATORIO_GERAR_INVENTARIO_IBP: 'relatorio<>inventario_ibp',
    RELATORIO_GERAR_ESTOQUE_ALMOXARIFADO: 'relatorio<>gerar_estoque_almoxarifado',
    RELATORIO_GERAR_LEVANTAMENTO_MATERIAIS: 'relatorio<>gerar_levantamento_materiais',
    RELATORIO_GERAR_INCONSISTENCIAS: 'relatorio<>gerar_inconsistencias',
    RELATORIO_GERAR_MATERIAIS_CONSUMIDOS: 'relatorio<>gerar_materiais_consumidos',
    RELATORIO_GERAR_MOVIMENTACAO_MATERIAIS: 'relatorio<>gerar_relatorio_movimentacao_materiais',
    RELATORIO_GERAR_MOVIMENTACAO_MATERIAIS_IBP: 'relatorio<>gerar_relatorio_movimentacao_materiais_ibp',
    RELATORIO_GERAR_MOVIMENTACAO_MATERIAIS_POR_NATUREZA_DESPESA: 'relatorio<>gerar_relatorio_movimentacao_materiais_por_natureza',
    RELATORIO_GERAR_MOVIMENTACAO_MATERIAIS_CONSUMIDOS: 'relatorio<>gerar_relatorio_materiais_consumidos',
    RELATORIO_GERAR_RELATORIO_INVENTARIO_DETALHADO: 'relatorio<>gerar_relatorio_inventario_detalhado',
    RELATORIO_GERAR_RELATORIO_FINANCEIRO: 'relatorio<>gerar_relatorio_financeiro',
    RELATORIO_GERAR_ENTRADA_MATERIAIS_NATUREZA_DESPESA: 'relatorio<>gerar_relatorio_entrada_materiais_por_natureza_despesa',
    RELATORIO_GERAR_CATALOGO_PRODUTO_PENDENTE: 'relatorio<>gerar_relatorio_itens_pendentes_catalogo',
    RELATORIO_QUANTITATIVO_BENS_PATRIMONIAIS: 'relatorio<>gerar_relatorio_quantitativo_bens_patrimoniais',
    RELATORIO_CONSOLIDADO_ALMOXARIFADO_NATUREZA_DESPESA: 'relatorio<>gerar_consolidado_almoxarifado_naturezad_despesa',
    RELATORIO_ETIQUETA_PRODUTOS: 'relatorio<>etiqueta_produtos',
    RELATORIO_CONFERENCIA_LOCALIZACOES: 'relatorio<>conferencia_localizacoes',
    RELATORIO_CURVA_ABC: 'relatorio<>curva_abc_consumo',
    RELATORIO_CONSOLIDADO_IBP_NATUREZA_DESPESA: 'relatorio<>gerar_consolidado_ibp_natureza_despesa',
    RELATORIO_BENS_DISTRIBUICAO_TOMBAMENTO: 'relatorio<>gerar_bens_distribuicao_tombamento',
    RELATORIO_FOTOS_IBP: 'relatorio<>gerar_rel_fotos_ibp',


    // ---> Modulo Compras

    //gasto p/modalidade
    GASTO_MOD_ACESSAR: 'gasto_modalidade<>acessar',

    //requisicao
    REQUISICAO_ACESSAR: 'requisicao<>acessar',
    REQUISICAO_INCLUIR: 'requisicao<>incluir',
    REQUISICAO_EDITAR: 'requisicao<>editar',
    REQUISICAO_EXCLUIR: 'requisicao<>excluir',
    REQUISICAO_ENVIAR: 'requisicao<>enviar',
    REQUISICAO_CANCEL_ENVIO: 'requisicao<>cancelar_envio',

    //pre-aprovacao
    PRE_APROVACAO_ACESSAR: 'preaprovacao<>acessar',
    PRE_APROVACAO_PARECER: 'preaprovacao<>parecer',
    PRE_APROVACAO_CONCLUIR: 'preaprovacao<>concluir',

    //processo
    PROCESSO_ACESSAR: 'processo<>acessar',

    //processo/processo
    ABA_PROCESSO_ACESSAR: 'processo/processo<>acessar_aba_processo',
    PROCESSO_INCLUIR: 'processo/processo<>incluir_proc',
    PROCESSO_EDITAR: 'processo/processo<>editar_proc',
    PROCESSO_ALTERAR_STATUS: 'processo/processo<>alterar_stuatus_proc',
    PROCESSO_PARECER: 'processo/processo<>parecer_proc',
    PROCESSO_ENCAMINHAR: 'processo/processo<>encaminhar_proc',
    PROCESSO_CANCELAR_ENC: 'processo/processo<>cancelar_encam_proc',
    AUTO_FORN_ACESSAR: 'processo/processo<>acessar_auto_forn',
    AUTO_FORN_INCLUIR: 'processo/processo<>incluir_auto_forn',
    AUTO_FORN_EDITAR: 'processo/processo<>editar_auto_forn',
    AUTO_FORN_EXCLUIR: 'processo/processo<>excluir_auto_forn',
    AUTO_FORN_RELATORIO: 'processo/processo<>relatorio_auto_forn',

    //processo/autorizacao
    ABA_AUTORIZACAO_ACESSAR: 'processo/autorizacao<>acessar_aba_autorizacao',
    AUTORIZACAO_INCLUIR: 'processo/autorizacao<>incluir_aut',
    AUTORIZACAO_EDITAR: 'processo/autorizacao<>editar_aut',
    AUTORIZACAO_ALTERAR_STATUS: 'processo/autorizacao<>alterar_stuatus_aut',
    AUTORIZACAO_PARECER: 'processo/autorizacao<>parecer_aut',
    AUTORIZACAO_ENCAMINHAR: 'processo/autorizacao<>encaminhar_aut',
    AUTORIZACAO_CANCELAR_ENC: 'processo/autorizacao<>cancelar_encam_aut',
    DOTACAO_ACESSAR: 'processo/autorizacao<>acessar_dotacao',
    DOTACAO_INCLUIR: 'processo/autorizacao<>incluir_dotacao',
    DOTACAO_EDITAR: 'processo/autorizacao<>editar_dotacao',
    DOTACAO_REMOVER: 'processo/autorizacao<>remover_dotacao',
    ORCAMENTO_ACESSAR: 'processo/autorizacao<>acessar_orcamento',
    ORCAMETNO_EDITAR: 'processo/autorizacao<>editar_orcamento',
    ORCAMENTO_INCLUIR: 'processo/autorizacao<>incluir_orcamento',
    ORCAMENTO_RELATORIO: 'processo/autorizacao<>relatorio_orcamento',

    //fonte recurso
    FONTE_RECURSO_ACESSAR: 'fonte_recurso<>acessar',
    FONTE_RECURSO_INCLUIR: 'fonte_recurso<>incluir',
    FONTE_RECURSO_EDITAR: 'fonte_recurso<>editar',

    //funcao
    FUNCAO_ACESSAR: 'funcao<>acessar',
    FUNCAO_INCLUIR: 'funcao<>incluir',
    FUNCAO_EDITAR: 'funcao<>editar',

    //sub_funcao
    SUB_FUNCAO_ACESSAR: 'sub_funcao<>acessar',
    SUB_FUNCAO_INCLUIR: 'sub_funcao<>incluir',
    SUB_FUNCAO_EDITAR: 'sub_funcao<>editar',

    //sub_acao
    SUB_ACAO_ACESSAR: 'sub_acao<>acessar',
    SUB_ACAO_INCLUIR: 'sub_acao<>incluir',
    SUB_ACAO_EDITAR: 'sub_acao<>editar',

    //sub_elemento_despesa
    SUB_ELEMENTO_DESPESA_ACESSAR: 'sub_elemento_despesa<>acessar',
    SUB_ELEMENTO_DESPESA_INCLUIR: 'sub_elemento_despesa<>incluir',
    SUB_ELEMENTO_DESPESA_EDITAR: 'sub_elemento_despesa<>editar',


    // Modulo Compras <----


    // ---> Modulo Licitacao

    //contrato
    CONTRATO_INCLUIR: 'contrato<>incluir',
    CONTRATO_EDITAR: 'contrato<>editar',
    CONTRATO_EXCLUIR: 'contrato<>excluir',
    CONTRATO_ACESSAR_PRESTACAO_CONTAS: 'contrato<>acessar_prestacao_contas',
    CONTRATO_INCLUIR_PRESTACAO_CONTAS: 'contrato<>incluir_prestacao_contas',
    CONTRATO_EDITAR_PRESTACAO_CONTAS: 'contrato<>editar_prestacao_contas',
    CONTRATO_APROVAR_PRESTACAO_CONTAS: 'contrato<>aprovar_prestacao_contas',
    CONTRATO_APROVACAO_TECNICA_PRESTACAO_CONTAS: 'contrato<>aprovacao_tecnica_prestacao_contas',

    CONTRATO_ASSINAR: 'contrato<>assinar',
    CONTRATO_GERA_EXTRATO: 'contrato<>gera_extrato',
    CONTRATO_ADITIVO: 'contrato<>aditivo',
    CONTRATO_VISUALIZAR: 'contrato<>visualizar',

    //licitacao
    LICITACAO_ACESSAR: 'licitacao<>acessar',
    LICITACAO_INCLUIR: 'licitacao<>incluir',
    LICITACAO_EDITAR: 'licitacao<>editar',
    LICITACAO_VISUALIZA_CERTAME: 'licitacao<>visualiza_certame',
    LICITACAO_VISUALIZA_EQUIPE: 'licitacao<>visualiza_equipe',
    LICITACAO_VISUALIZA_AVISO: 'licitacao<>visualiza_aviso',

    LICITACAO_VISUALIZA_LICITACAO: 'licitacao<>visualiza_licitacao',
    LICITACAO_EQUIPE_INCLUIR: 'licitacao<>incluir_equipe',
    LICITACAO_EQUIPE_INCLUIR_PESSOA: 'licitacao<>incluir_pessoa_equipe',
    LICITACAO_EQUIPE_EDITAR_PESSOA: 'licitacao<>editar_pessoa_equipe',
    LICITACAO_EQUIPE_REMOVER_PESSOA: 'licitacao<>remover_pessoa_equipe',
    LICITACAO_EQUIPE_INCLUIR_CRONOGRAMA: 'licitacao<>incluir_cronograma',
    LICITACAO_EQUIPE_EDITAR_CRONOGRAMA: 'licitacao<>editar_cronograma',
    LICITACAO_EQUIPE_EXCLUIR_CRONOGRAMA: 'licitacao<>excluir_cronograma',
    LICITACAO_EQUIPE_ACESSAR_PERIODO_ATIVIDADE: 'licitacao<>acessar_periodo_atividade',
    LICITACAO_EQUIPE_INCLUIR_PERIODO_ATIVIDADE: 'licitacao<>incluir_periodo_atividade',
    LICITACAO_EQUIPE_EDITAR_PERIODO_ATIVIDADE: 'licitacao<>editar_periodo_atividade',
    LICITACAO_EQUIPE_REMOVER_PERIODO_ATIVIDADE: 'licitacao<>remover_periodo_atividade',
    LICITACAO_EQUIPE_INCLUIR_REUNIAO: 'licitacao<>incluir_reuniao',
    LICITACAO_EQUIPE_EDITAR_REUNIAO: 'licitacao<>editar_reuniao',
    LICITACAO_EQUIPE_EXCLUIR_REUNIAO: 'licitacao<>excluir_reuniao',
    LICITACAO_EDITAL_INCLUIR: 'licitacao<>incluir_edital',
    LICITACAO_EDITAL_EDITAR: 'licitacao<>editar_edital',
    LICITACAO_EDITAL_EXCLUIR: 'licitacao<>excluir_edital',
    LICITACAO_PROCESSO_ASSOCIAR: 'licitacao<>associar_processo',
    LICITACAO_PROCESSO_EXCLUIR: 'licitacao<>remover_processo',
    LICITACAO_PROCESSO_IMPORTAR_ITENS: 'licitacao<>importar_itens_processo',
    LICITACAO_ITEM_EDITAR: 'licitacao<>editar_item',
    LICITACAO_DOC_INCLUIR: 'licitacao<>incluir_doc',
    LICITACAO_DOC_EDITAR: 'licitacao<>editar_doc',
    LICITACAO_DOC_EXCLUIR: 'licitacao<>excluir_doc',
    LICITACAO_DOC_IMPORTAR: 'licitacao<>importar_doc',
    LICITACAO_END_INCLUIR: 'licitacao<>incluir_end',
    LICITACAO_END_EDITAR: 'licitacao<>editar_end',
    LICITACAO_END_EXCLUIR: 'licitacao<>excluir_end',
    LICITACAO_PONTUACAO_INCLUIR: 'licitacao<>incluir_pontuacao',

    //cronograma_departamento
    CRONOGRAMA_DEPARTAMENTO_ACESSAR: 'cronograma_departamento<>acessar',
    CRONOGRAMA_DEPARTAMENTO_INCLUIR: 'cronograma_departamento<>incluir',
    CRONOGRAMA_DEPARTAMENTO_EDITAR: 'cronograma_departamento<>editar',
    CRONOGRAMA_DEPARTAMENTO_ATIVIDADE_ACESSAR: 'cronograma_departamento<>acessar_atividade',
    CRONOGRAMA_DEPARTAMENTO_ATIVIDADE_INCLUIR: 'cronograma_departamento<>incluir_atividade',
    CRONOGRAMA_DEPARTAMENTO_ATIVIDADE_EDITAR: 'cronograma_departamento<>editar_atividade',

    //publicacao_licitacao
    PUBLICACAO_LICITACAO_ACESSAR: 'publicacao_licitacao<>acessar',
    PUBLICACAO_LICITACAO_INCLUIR: 'publicacao_licitacao<>incluir',
    PUBLICACAO_LICITACAO_EDITAR: 'publicacao_licitacao<>editar',

    //indicador_criterio
    INDICADOR_CRITERIO_ACESSAR: 'indicador_criterio<>acessar',
    INDICADOR_CRITERIO_INCLUIR: 'indicador_criterio<>incluir',
    INDICADOR_CRITERIO_EDITAR: 'indicador_criterio<>editar',

    //grupo_criterio
    GRUPO_CRITERIO_ACESSAR: 'grupo_criterio<>acessar',
    GRUPO_CRITERIO_INCLUIR: 'grupo_criterio<>incluir',
    GRUPO_CRITERIO_EDITAR: 'grupo_criterio<>editar',
    GRUPO_CRITERIO_EXCLUIR: 'grupo_criterio<>excluir',

    //criterio
    CRITERIO_ACESSAR: 'criterio<>acessar',
    CRITERIO_INCLUIR: 'criterio<>incluir',
    CRITERIO_EDITAR: 'criterio<>editar',
    CRITERIO_EXCLUIR: 'criterio<>excluir',

    //fase_licitacao
    FASE_LICITACAO_ACESSAR: 'fase_licitacao<>acessar',
    FASE_LICITACAO_INCLUIR: 'fase_licitacao<>incluir',
    FASE_LICITACAO_EDITAR: 'fase_licitacao<>editar',

    //funcao_equipe
    FUNCAO_EQUIPE_ACESSAR: 'funcao_equipe<>acessar',
    FUNCAO_EQUIPE_INCLUIR: 'funcao_equipe<>incluir',
    FUNCAO_EQUIPE_EDITAR: 'funcao_equipe<>editar',

    //grupo_contrato
    GRUPO_CONTRATO_ACESSAR: 'grupo_contrato<>acessar',
    GRUPO_CONTRATO_INCLUIR: 'grupo_contrato<>incluir',
    GRUPO_CONTRATO_EDITAR: 'grupo_contrato<>editar',

    //texto_padrao
    TEXTO_PADRAO_ACESSAR: 'texto_padrao<>acessar',
    TEXTO_PADRAO_INCLUIR: 'texto_padrao<>incluir',
    TEXTO_PADRAO_EDITAR: 'texto_padrao<>editar',

    //modelo_documento_edital
    MODELO_DOCUMENTO_EDITAL_ACESSAR: 'modelo_documento_edital<>acessar',
    MODELO_DOCUMENTO_EDITAL_INCLUIR: 'modelo_documento_edital<>incluir',
    MODELO_DOCUMENTO_EDITAL_EDITAR: 'modelo_documento_edital<>editar',

    //publicacao
    PUBLICACAO_ACESSAR: 'publicacao<>acessar',
    PUBLICACAO_INCLUIR: 'publicacao<>incluir',
    PUBLICACAO_EDITAR: 'publicacao<>editar',

    //regime_execucao
    REGIME_EXECUCAO_EDITAL_ACESSAR: 'regime_execucao<>acessar',
    REGIME_EXECUCAO_EDITAL_INCLUIR: 'regime_execucao<>incluir',
    REGIME_EXECUCAO_EDITAL_EDITAR: 'regime_execucao<>editar',

    //tipo_contrato
    TIPO_CONTRATO_ACESSAR: 'tipo_contrato<>acessar',
    TIPO_CONTRATO_INCLUIR: 'tipo_contrato<>incluir',
    TIPO_CONTRATO_EDITAR: 'tipo_contrato<>editar',
    TIPO_CONTRATO_EXCLUIR: 'tipo_contrato<>excluir',

    //tipo_envelope
    TIPO_ENVELOPE_ACESSAR: 'tipo_envelope<>acessar',
    TIPO_ENVELOPE_INCLUIR: 'tipo_envelope<>incluir',
    TIPO_ENVELOPE_EDITAR: 'tipo_envelope<>editar',

    //tipo_licitacao
    TIPO_LICITACAO_ACESSAR: 'tipo_licitacao<>acessar',
    TIPO_LICITACAO_INCLUIR: 'tipo_licitacao<>incluir',
    TIPO_LICITACAO_EDITAR: 'tipo_licitacao<>editar',

    //tipo_orgao
    TIPO_ORGAO_ACESSAR: 'tipo_orgao<>acessar',
    TIPO_ORGAO_INCLUIR: 'tipo_orgao<>incluir',
    TIPO_ORGAO_EDITAR: 'tipo_orgao<>editar',

    //tipo_resultado
    TIPO_RESULTADO_ACESSAR: 'tipo_resultado<>acessar',
    TIPO_RESULTADO_INCLUIR: 'tipo_resultado<>incluir',
    TIPO_RESULTADO_EDITAR: 'tipo_resultado<>editar',

    //tipo_reuniao
    TIPO_REUNIAO_ACESSAR: 'tipo_reuniao<>acessar',
    TIPO_REUNIAO_INCLUIR: 'tipo_reuniao<>incluir',
    TIPO_REUNIAO_EDITAR: 'tipo_reuniao<>editar',

    //tipo_gestor_contrato
    TIPO_GESTOR_CONTRATO_ACESSAR: 'tipo_gestor_contrato<>acessar',
    TIPO_GESTOR_CONTRATO_INCLUIR: 'tipo_gestor_contrato<>incluir',
    TIPO_GESTOR_CONTRATO_EDITAR: 'tipo_gestor_contrato<>editar',

    //cronograma_desembolso
    CRONOGRAMA_DESEMBOLSO_ACESSAR: 'cronograma_desembolso<>acessar',
    CRONOGRAMA_DESEMBOLSO_INCLUIR: 'cronograma_desembolso<>incluir',
    CRONOGRAMA_DESEMBOLSO_EDITAR: 'cronograma_desembolso<>editar',


    //  Modulo Licitacao <----

    // ---> Modulo Almoxarifado
    GERAR_DADOS_TRANSPARENCIA: 'gerar_dados_transparencia<>acessar',

    //retirada pedido
    RETIRADA_PEDIDO_ACESSAR: 'retirada_pedido<>acessar',

    //Configuracao de produtos do departamento
    CONFIG_PROD_DEPART_ACESSAR: 'config_prod_depart<>acessar',
    CONFIG_PROD_DEPART_EDITAR: 'config_prod_depart<>editar',

    //pedido
    PEDIDO_ACESSAR: 'pedido<>acessar',
    PEDIDO_INCLUIR: 'pedido<>incluir',
    PEDIDO_EDITAR: 'pedido<>editar',
    PEDIDO_EXCLUIR: 'pedido<>excluir',
    PEDIDO_ENVIAR: 'pedido<>enviar',

    PEDIDO_RETIRAR: 'pedido<>retirar',
    PEDIDO_ENTREGAR: 'pedido<>entregar',
    PEDIDO_APROVACAO: 'pedido<>aprovacao',
    PEDIDO_RECEBER: 'pedido<>receber',
    PEDIDO_SELECIONAR_OUTRA_UA: 'pedido<>selecionar_outra_ua',

    //especidicacoes materiais
    ESPECIFICACAO_MATERIAIS_ACESSAR: 'especificacao_materiais<>acessar',
    ESPECIFICACAO_MATERIAIS_INCLUIR: 'especificacao_materiais<>incluir',
    ESPECIFICACAO_MATERIAIS_EDITAR: 'especificacao_materiais<>editar',

    //historico registro contabil
    // HISTORICO_REGISTRO_CONTABIL_ACESSAR:'historico_registro_contabil<>acessar',
    // HISTORICO_REGISTRO_CONTABIL_INCLUIR:'historico_registro_contabil<>incluir',

    //operaca-o item bem consumo
    OPERACAO_ITEM_BEM_CONSUMO_ACESSAR: 'operacao_item_bem_consumo<>acessar',
    OPERACAO_ITEM_BEM_CONSUMO_EXCLUIR_BAIXA: 'operacao_item_bem_consumo<>excluir_baixa',

    //almoxarifado
    ALMOXARIFADO_ACESSAR: 'almoxarifado<>acessar',
    ALMOXARIFADO_INCLUIR: 'almoxarifado<>incluir',
    ALMOXARIFADO_EDITAR: 'almoxarifado<>editar',
    ALMOXARIFADO_EXCLUIR: 'almoxarifado<>excluir',
    ALMOXARIFADO_BLOQUEAR: 'almoxarifado<>bloquear',
    ALMOXARIFADO_CONFIGURAR: 'almoxarifado<>configurar',
    ALMOXARIFADO_ADICIONAR_UNIDADE_PRODUTO: 'almoxarifado<>adicionar_unidade_produto',

    //item bem consumo
    ITEM_BEM_CONSUMO_ACESSAR: 'item_bem_consumo<>acessar',
    ITEM_BEM_CONSUMO_TRANSF_CENTRO_CUSTO: 'item_bem_consumo<>transf_centro_custo',
    ITEM_BEM_CONSUMO_TRANSF_PATRIMONIO: 'item_bem_consumo<>transf_patrimonio',
    ITEM_BEM_CONSUMO_TRANSF_DEPART: 'item_bem_consumo<>transf_depart',

    //baixa de item bem consumo
    BAIXA_ITEM_BEM_CONSUMO_ACESSAR: 'baixa_item_bem_consumo<>acessar',
    BAIXA_ITEM_BEM_CONSUMO_INCLUIR: 'baixa_item_bem_consumo<>incluir',
    BAIXA_ITEM_BEM_CONSUMO_EDITAR: 'baixa_item_bem_consumo<>editar',

    //foto item bem consumo
    FOTO_ITEM_BEM_CONSUMO_ACESSAR: 'foto_item_bem_consumo<>acessar',
    FOTO_ITEM_BEM_CONSUMO_EXCLUIR: 'foto_item_bem_consumo<>excluir',
    FOTO_ITEM_BEM_CONSUMO_INCLUIR: 'foto_item_bem_consumo<>incluir',
    FOTO_ITEM_BEM_CONSUMO_EDITAR: 'foto_item_bem_consumo<>editar',

    //documento item bem consumo
    DOCUMENTO_ITEM_BEM_CONSUMO_ACESSAR: 'documento_item_bem_consumo<>acessar',
    /*			 DOCUMENTO_ITEM_BEM_CONSUMO_EXCLUIR:'documento_item_bem_consumo<>excluir',*/
    DOCUMENTO_ITEM_BEM_CONSUMO_INCLUIR: 'documento_item_bem_consumo<>incluir',
    DOCUMENTO_ITEM_BEM_CONSUMO_EDITAR: 'documento_item_bem_consumo<>editar',

    //transferencias
    TRANSFERENCIAS_ACESSAR: 'transferencias<>acessar',
    TRANSFERENCIAS_APROVAR: 'transferencias<>aprovar',
    TRANSFERENCIAS_REPROVAR: 'transferencias<>reprovar',
    TRANSFERENCIAS_ESTORNAR: 'transferencias<>estornar',

    //item bem de consumo departamento
    ITEM_BEM_CONS_DEPART_ACESSAR: 'item_bem_consumo_departamento<>acessar',
    ITEM_BEM_CONS_DEPART_CONFIG: 'item_bem_consumo_departamento<>configuracoes',
    ITEM_BEM_CONS_DEPART_BAIXA: 'item_bem_consumo_departamento<>baixa',
    ITEM_BEM_CONS_DEPART_LOC_FISICA: 'item_bem_consumo_departamento<>loc_fisica',

    //operacao item bem permanente
    OP_ITEM_BEM_PERMANENTE_ACESSAR: 'op_item_bem_permanente<>acessar',

    //inventarios
    INVENTARIOS_ACESSAR: 'inventarios<>acessar',
    INVENTARIOS_INCLUIR: 'inventarios<>incluir',
    INVENTARIOS_CONTINUAR: 'inventarios<>continuar',
    INVENTARIOS_VISUALIZAR: 'inventarios<>visualizar',

    //solicitacao inclusao de produto
    SOL_INCL_PROD_ACESSAR: 'sol_incl_produto<>acessar',
    SOL_INCL_PROD_INCLUIR: 'sol_incl_produto<>incluir',
    SOL_INCL_PROD_EDITAR: 'sol_incl_produto<>editar',
    SOL_INCL_PROD_DAR_PARECER: 'sol_incl_produto<>dar_parecer',
    SOL_INCL_PROD_ENVIAR: 'sol_incl_produto<>enviar',
    SOL_INCL_PROD_CANCELAR_ENVIO: 'sol_incl_produto<>cancelar_envio',
    SOL_INCL_PROD_GERAR_PRODUTO: 'sol_incl_produto<>gerar_produto',
    SOL_INCL_PROD_RECEBER: 'sol_incl_produto<>receber',
    SOL_INCL_PROD_VISUALIZA_TRAMITACAO: 'sol_incl_produto<>visualiza_tramitacao',

    //local armazenamento
    LOCAL_ARMAZENAMENTO_ACESSAR: 'local_armazenamento<>acessar',
    LOCAL_ARMAZENAMENTO_INCLUIR: 'local_armazenamento<>incluir',
    LOCAL_ARMAZENAMENTO_EDITAR: 'local_armazenamento<>editar',


    //movimentacao item bem consumo
    MOV_ITEM_BEM_CONSUMO_ACESSAR: 'mov_item_bem_consumo<>acessar',
    MOV_ITEM_BEM_CONSUMO_APROVACAO: 'mov_item_bem_consumo<>aprovacao',
    MOV_ITEM_BEM_CONSUMO_EXCLUIR: 'mov_item_bem_consumo<>excluir',
    MOV_ITEM_BEM_CONSUMO_INCLUIR: 'mov_item_bem_consumo<>incluir',
    MOV_ITEM_BEM_CONSUMO_EDITAR: 'mov_item_bem_consumo<>editar',
    MOV_ITEM_BEM_CONSUMO_ENVIAR: 'mov_item_bem_consumo<>enviar',

    //configuracao cota departamento
    CONFIGURACAO_COTA_DEPARTAMENTO_ACESSAR: 'configuracao_cota_departamento<>acessar',

    //configuracao almoxarifado
    CONFIGURACAO_ALMOXARIFADO_ACESSAR: 'configuracao_almoxarifado<>acessar',

    //departamento local armazenamento
    DEPARTAMENTO_LOCAL_ARMAZENAMENTO_ACESSAR: 'departamento_local_armazenamento<>acessar',

    //  Modulo Almoxarifado <----

    // ---> Modulo Patrimonio

    //agendamento de depreciacao/valorizacao
    AGEND_DEPRE_VAL_ACESSAR: 'agend_depre_val<>acessar',
    AGEND_DEPRE_VAL_INCLUIR: 'agend_depre_val<>incluir',
    AGEND_DEPRE_VAL_EDITAR: 'agend_depre_val<>editar',

    //apolice seguro
    APOLICE_SEGURO_ACESSAR: 'apolice_seguro<>acessar',
    APOLICE_SEGURO_INCLUIR: 'apolice_seguro<>incluir',
    APOLICE_SEGURO_EDITAR: 'apolice_seguro<>editar',

    //Auditoria do Item Bem Permanente
    AUDIT_BEM_PERMANENTE_ACESSAR: 'audit_bem_permanente<>acessar',
    AUDIT_BEM_PERMANENTE_INCLUIR: 'audit_bem_permanente<>incluir',
    AUDIT_BEM_PERMANENTE_EDITAR: 'audit_bem_permanente<>editar',
    AUDIT_BEM_PERMANENTE_EXCLUIR: 'audit_bem_permanente<>excluir',

    //Solicitação Inventário do Item Bem Permanente
    SOLICITACAO_INVENTARIO_BEM_PERMANENTE_ACESSAR: 'solicitacao_inventario<>acessar',
    SOLICITACAO_INVENTARIO_BEM_PERMANENTE_INCLUIR: 'solicitacao_inventario<>incluir',
    SOLICITACAO_INVENTARIO_BEM_PERMANENTE_EDITAR: 'solicitacao_inventario<>editar',
    SOLICITACAO_INVENTARIO_BEM_PERMANENTE_EXCLUIR: 'solicitacao_inventario<>excluir',
    SOLICITACAO_INVENTARIO_BEM_PERMANENTE_ENVIAR: 'solicitacao_inventario<>enviar',

    //Baixa de Item Bem Permanente
    BAIXA_BEM_PERMANENTE_ACESSAR: 'baixa_bem_permanente<>acessar',
    BAIXA_BEM_PERMANENTE_INCLUIR: 'baixa_bem_permanente<>incluir',
    BAIXA_BEM_PERMANENTE_EDITAR: 'baixa_bem_permanente<>editar',
    BAIXA_BEM_PERMANENTE_ESTORNAR: 'baixa_bem_permanente<>estornar',

    //Bem em Apuração
    SOLICITACAO_BENS_EM_APURACAO_ACESSAR: 'solicitacao_bens_em_apuracao<>acessar',
    SOLICITACAO_BENS_EM_APURACAO_INCLUIR: 'solicitacao_bens_em_apuracao<>incluir',
    SOLICITACAO_BENS_EM_APURACAO_INATIVAR: 'solicitacao_bens_em_apuracao<>inativar',


    //Bem de Terceiro
    BEM_TERCEIRO_ACESSAR: 'bem_terceiro<>acessar',
    BEM_TERCEIRO_INCLUIR: 'bem_terceiro<>incluir',
    BEM_TERCEIRO_EDITAR: 'bem_terceiro<>editar',
    BEM_TERCEIRO_ATIVAR_INATIVAR: 'bem_terceiro<>ativar_inativar',
    BEM_TERCEIRO_ANEXAR: 'bem_terceiro<>anexar',


    //Empréstimo de Item Bem Permanente
    EMPRESTIMO_BEM_PERMANENTE_ACESSAR: 'emprestimo_bem_permanente<>acessar',
    EMPRESTIMO_BEM_PERMANENTE_EDITAR: 'emprestimo_bem_permanente<>editar',
    EMPRESTIMO_BEM_PERMANENTE_INCLUIR: 'emprestimo_bem_permanente<>incluir',
    EMPRESTIMO_BEM_PERMANENTE_GERA_RELATORIO: 'emprestimo_bem_permanente<>gera_relatorio',

    //Item Bem Permanente
    ITEM_BEM_PERMANENTE_ACESSAR: 'item_bem_permanente<>acessar',
    ITEM_BEM_PERMANENTE_INCLUIR: 'item_bem_permanente<>incluir',
    ITEM_BEM_PERMANENTE_OPERACOES_ACESSAR: 'item_bem_permanente<>acessar_operacoes',
    ITEM_BEM_PERMANENTE_DUPLICAR: 'item_bem_permanente<>duplicar',
    ITEM_BEM_PERMANENTE_EDITAR: 'item_bem_permanente<>editar',
    ITEM_BEM_PERMANENTE_VISUALIZAR: 'item_bem_permanente<>visualizar',
    ITEM_BEM_PERMANENTE_EDITAR_UTILIZADO_POR: 'item_bem_permanente<>editar_utilizado_por',
    ITEM_BEM_PERMANENTE_DOCUMENTOS_ACESSAR: 'item_bem_permanente<>acessar_documentos',
    ITEM_BEM_PERMANENTE_DOCUMENTOS_INCLUIR: 'item_bem_permanente<>incluir_documentos',
    ITEM_BEM_PERMANENTE_DOCUMENTOS_EDITAR: 'item_bem_permanente<>editar_documentos',
    ITEM_BEM_PERMANENTE_MANUTENCAO_ACESSAR: 'item_bem_permanente<>acessar_manutencao',
    ITEM_BEM_PERMANENTE_MANUTENCAO_INCLUIR: 'item_bem_permanente<>incluir_manutencao',
    ITEM_BEM_PERMANENTE_MANUTENCAO_EDITAR: 'item_bem_permanente<>editar_manutencao',
    ITEM_BEM_PERMANENTE_MANUTENCAO_EXCLUIR: 'item_bem_permanente<>excluir_manutencao',
    ITEM_BEM_PERMANENTE_AVALIACAO_ACESSAR: 'item_bem_permanente<>acessar_avaliacao',
    ITEM_BEM_PERMANENTE_AVALIACAO_INCLUIR: 'item_bem_permanente<>incluir_avaliacao',
    ITEM_BEM_PERMANENTE_AVALIACAO_EDITAR: 'item_bem_permanente<>editar_avaliacao',
    ITEM_BEM_PERMANENTE_AVALIACAO_EXCLUIR: 'item_bem_permanente<>excluir_avaliacao',
    ITEM_BEM_PERMANENTE_DEPRE_VAL_ACESSAR: 'item_bem_permanente<>acessar_depre_val',
    ITEM_BEM_PERMANENTE_DEPRE_VAL_INCLUIR: 'item_bem_permanente<>incluir_depre_val',
    ITEM_BEM_PERMANENTE_DEPRE_VAL_EDITAR: 'item_bem_permanente<>editar_depre_val',
    ITEM_BEM_PERMANENTE_DEPRE_VAL_EXCLUIR: 'item_bem_permanente<>excluir_depre_val',
    ITEM_BEM_PERMANENTE_RESPONSABILIDADE_ACESSAR: 'item_bem_permanente<>acessar_responsabilidade',
    ITEM_BEM_PERMANENTE_AGREGACAO: 'item_bem_permanente<>agregacao',
    ITEM_BEM_PERMANENTE_DESBLOQUEIO: 'item_bem_permanente<>desbloqueio',
    ITEM_BEM_PERMANENTE_CONSULTA_QUALQUER: 'item_bem_permanente<>consulta_ibp_qualquer',
    ITEM_BEM_PERMANENTE_ACESSO_ORGANOGRAMA: 'item_bem_permanente<>acesso_organograma',
    ITEM_BEM_PERMANENTE_PODE_INSERIR_LOCAIS_NAO_AUTORIZADOS: 'item_bem_permanente<>pode_inserir_locais_nao_autorizados',

    // Transferencia de Responsabilidade
    TRANSFERENCIA_RESPONSABILIDADE_ACESSAR: 'transferencia_responsabilidade<>acessar',
    TRANSFERENCIA_RESPONSABILIDADE_INCLUIR: 'transferencia_responsabilidade<>incluir',
    TRANSFERENCIA_RESPONSABILIDADE_EXCLUIR: 'transferencia_responsabilidade<>excluir',

    // Histórico de Lotação
    LOTACAO_BEM_PERMANENTE_ACESSAR: 'lotacao_bem_permanente<>acessar',

    //Depreciação
    DEPRECIACAO_IBP_GERAR_RELATORIO: 'depreciacao<>gerar_relatorio',

    // tipo registro entrada
    TIPO_REGISTRO_ENTRADA_ACESSAR: 'tipo_registro_entrada<>acessar',
    TIPO_REGISTRO_ENTRADA_INCLUIR: 'tipo_registro_entrada<>incluir',
    TIPO_REGISTRO_ENTRADA_EDITAR: 'tipo_registro_entrada<>editar',

    // Tipo material
    TIPO_MATERIAL_ACESSAR: 'tipo_material<>acessar',
    TIPO_MATERIAL_INCLUIR: 'tipo_material<>incluir',
    TIPO_MATERIAL_EDITAR: 'tipo_material<>editar',

    // Classificacao Tipo material
    CLASS_TIPO_MATERIAL_ACESSAR: 'classificacao_tipo_material<>acessar',
    CLASS_TIPO_MATERIAL_INCLUIR: 'classificacao_tipo_material<>incluir',
    CLASS_TIPO_MATERIAL_EDITAR: 'classificacao_tipo_material<>editar',

    // Status guia saida
    STATUS_GUIA_SAIDA_ACESSAR: 'status_guia_saida<>acessar',
    STATUS_GUIA_SAIDA_INCLUIR: 'status_guia_saida<>incluir',
    STATUS_GUIA_SAIDA_EDITAR: 'status_guia_saida<>editar',

    // Motivo agregacao
    MOTIVO_AGREGACAO_ACESSAR: 'motivo_agregacao<>acessar',
    MOTIVO_AGREGACAO_INCLUIR: 'motivo_agregacao<>incluir',
    MOTIVO_AGREGACAO_EDITAR: 'motivo_agregacao<>editar',

    // Simulacao Agendamento Depreciacao/Valorizacao
    SIMU_AGEND_DEPRE_VAL_ACESSAR: 'simu_agend_depre_val<>acessar',

    // Sub Classificação Tipo Material
    SUB_CLASS_TIPO_MATERIAL_ACESSAR: 'sub_class_tipo_material<>acessar',
    SUB_CLASS_TIPO_MATERIAL_INCLUIR: 'sub_class_tipo_material<>incluir',
    SUB_CLASS_TIPO_MATERIAL_EDITAR: 'sub_class_tipo_material<>editar',


    //Registro de Entrada
    REG_ENTRADA_ACESSAR: 'reg_entrada<>acessar',
    REG_ENTRADA_INCLUIR: 'reg_entrada<>incluir',
    REG_ENTRADA_EDITAR: 'reg_entrada<>editar',
    REG_ENTRADA_DATALHAMENTO: 'reg_entrada<>detalhamento',
    REGISTRO_ENTRADA_DOCUMENTOS_INCLUIR: 'reg_entrada<>incluir_documentos',

    //Retirada de Item Bem Permanente
    RET_BEM_PERMANENTE_ACESSAR: 'ret_bem_permanente<>acessar',
    RET_BEM_PERMANENTE_INCLUIR: 'ret_bem_permanente<>incluir',
    RET_BEM_PERMANENTE_EDITAR: 'ret_bem_permanente<>editar',

    //Solicitação Movimentação
    SOLICITACAO_MOV_ACESSAR: 'solicitacao_mov<>acessar',
    SOLICITACAO_MOV_INCLUIR: 'solicitacao_mov<>incluir',
    SOLICITACAO_MOV_EDITAR: 'solicitacao_mov<>editar',
    SOLICITACAO_MOV_ENVIAR: 'solicitacao_mov<>enviar',
    SOLICITACAO_MOV_APROVACAO: 'solicitacao_mov<>aprovacao',
    SOLICITACAO_MOV_FINALIZAR_MOV: 'solicitacao_mov<>finalizar_movimentacao',

    //tipo estado conservacao
    TIPO_ESTADO_CONSERVACAO_ACESSAR: 'tipo_estado_conservacao<>acessar',
    TIPO_ESTADO_CONSERVACAO_INCLUIR: 'tipo_estado_conservacao<>incluir',
    TIPO_ESTADO_CONSERVACAO_EDITAR: 'tipo_estado_conservacao<>editar',

    //tipo manutencao
    TIPO_MANUTENCAO_ACESSAR: 'tipo_manutencao<>acessar',
    TIPO_MANUTENCAO_INCLUIR: 'tipo_manutencao<>incluir',
    TIPO_MANUTENCAO_EDITAR: 'tipo_manutencao<>editar',

    //tipo problema
    TIPO_PROBLEMA_ACESSAR: 'tipo_problema<>acessar',
    TIPO_PROBLEMA_INCLUIR: 'tipo_problema<>incluir',
    TIPO_PROBLEMA_EDITAR: 'tipo_problema<>editar',

    //tarefa processo
    TAREFA_PROCESSO_ACESSAR: 'tarefa_processo<>acessar',
    TAREFA_PROCESSO_INICIAR: 'tarefa_processo<>iniciar',
    TAREFA_PROCESSO_DEPARTAMENTO_ACESSAR: 'tarefa_processo<>acessar_departamento',

    //configuracao processo
    CONFIGURACAO_PROCESSO_ACESSAR: 'configuracao_processo<>acessar',
    CONFIGURACAO_PROCESSO_EDITAR: 'configuracao_processo<>editar',
    CONFIGURACAO_PROCESSO_INCLUIR: 'configuracao_processo<>incluir',

    //duplicacao item bem permanente
    DUPLICACAO_BEM_PERMANENTE_ACESSAR: 'duplicacao_bem_permanente<>acessar',

    //Configuração do Catalogo
    CONFIGURACAO_CATALOGO_ACESSAR: 'configuracao_catalogo<>acessar',
    CONFIGURACAO_CATALOGO_INCLUIR: 'configuracao_catalogo<>incluir',
    CONFIGURACAO_CATALOGO_EDITAR: 'configuracao_catalogo<>editar',
    CONFIGURACAO_CATALOGO_EXCLUIR: 'configuracao_catalogo<>excluir',
    CONFIGURACAO_CATALOGO_ACESSAR_FOTOS: 'configuracao_catalogo<>acessar_fotos',
    CONFIGURACAO_CATALOGO_ACESSAR_ANEXOS: 'configuracao_catalogo<>acessar_anexos',
    CONFIGURACAO_CATALOGO_ALTERAR_VISIBILIDADE: 'configuracao_catalogo<>alterar_visibilidade',
    CONFIGURACAO_CATALOGO_CONFIG_UND_ADM_ESPECIFICA: 'configuracao_catalogo<>configurar_und_adm_especifica',
    //Pedidos do Catálogo
    PEDIDO_CATALOGO_ACESSAR: 'pedidos_catalogo<>acessar',
    PEDIDO_CATALOGO_APROVAR: 'pedidos_catalogo<>aprovar',
    PEDIDO_CATALOGO_FINALIZAR: 'pedidos_catalogo<>finalizar',
    PEDIDO_CATALOGO_INCLUIR_ITEM_BEM_PERMANENTE: 'pedidos_catalogo<>incluir_itembempermanente',
    PEDIDO_CATALOGO_SOL_MOV_IBP: 'pedidos_catalogo<>gerar_sol_mov_itembempermanente', //Gerar Solicitação Movimentação de Item Bem Permanente
    PEDIDO_CATALOGO_EDITAR: 'pedidos_catalogo<>editar',
    //Catálogo do Patrimônio
    CATALOGO_PATRIMONIO_ACESSAR: 'catalogo_patrimonio<>acessar',
    CATALOGO_PATRIMONIO_ACESSAR_CARRINHO: 'catalogo_patrimonio<>acessar_carrinho',
    CATALOGO_PATRIMONIO_ACESSAR_PEDIDOS: 'catalogo_patrimonio<>acessar_pedidos',
    CATALOGO_PATRIMONIO_ENVIAR_PEDIDO: 'catalogo_patrimonio<>enviar_pedido',
    //Processo de Compra
    CATOLOGO_GERENCIAR_PROCESSOS_COMPRAS_ACESSAR: 'gerenciar_processos_compras<>acessar',
    CATALOGO_GERENCIAR_PROCESSOS_COMPRAS_GERAR: 'gerenciar_processos_compras<>gerar',

    //Sincronização RFID
    IMPORTAR_DADOS_PARA_SPALM: 'sincronizacao_rfid<>importar_dados_para_spalm',
    IMPORTAR_DADOS_PARA_COLETOR: 'sincronizacao_rfid<>importar_dados_para_coletor',


    //  Modulo Patrimonio <----


    // ---> Modulo Administrador

    //administracao
    ADM_ACESSAR: 'administracao<>acessar',

    //Config. Modalidade
    CONFIG_MOD_ACESSAR: 'config_modalidade<>acessar',
    CONFIG_MOD_INCLUIR: 'config_modalidade<>incluir',
    CONFIG_MOD_EDITAR: 'config_modalidade<>editar',

    //Config. Doc. Padrão  Licitação
    CONFIG_DOC_PADRAO_ACESSAR: 'config_doc_padrao_licit<>acessar',
    CONFIG_DOC_PADRAO_INCLUIR: 'config_doc_padrao_licit<>incluir',

    //Config. Sistema
    CONFIG_SISTEMA_ACESSAR: 'config_sistema<>acessar',
    CONFIG_SISTEMA_INCLUIR: 'config_sistema<>incluir',
    CONFIG_SISTEMA_EDITAR: 'config_sistema<>editar',

    //  Modulo Administrador <----

    // ---> Modulo Frotas

    //deslocamento veiculos
    DESLOCAMENTO_VEICULO_ACESSAR: 'deslocamento_veiculo<>acessar',
    DESLOCAMENTO_VEICULO_EDITAR: 'deslocamento_veiculo<>editar',
    DESLOCAMENTO_VEICULO_INCLUIR: 'deslocamento_veiculo<>incluir',
    DESLOCAMENTO_VEICULO_GERENCIAR_ROTEIRO: 'deslocamento_veiculo<>gerenciar_roteiro',

    //motorista
    MOTORISTA_ACESSAR: 'motorista<>acessar',
    MOTORISTA_EDITAR: 'motorista<>editar',
    MOTORISTA_INCLUIR: 'motorista<>incluir',

    //prestacao de contas
    PRESTACAO_CONTAS_ACESSAR: 'prestacao_contas<>acessar',
    PRESTACAO_CONTAS_VISUALIZA_TRAMITACAO: 'prestacao_contas<>visualiza_tramitacao',
    PRESTACAO_CONTAS_RECEBER: 'prestacao_contas<>receber',
    PRESTACAO_CONTAS_INLCUIR: 'prestacao_contas<>incluir',
    PRESTACAO_CONTAS_ENVIAR: 'prestacao_contas<>enviar',
    PRESTACAO_CONTAS_EDITAR: 'prestacao_contas<>editar',
    PRESTACAO_CONTAS_CANCELAR_ENVIO: 'prestacao_contas<>cancelar_envio',
    PRESTACAO_CONTAS_DAR_PARECER: 'prestacao_contas<>dar_parecer',

    //solicitacao de deslocamento
    SOLICITACAO_DESLOCAMENTO_ACESSAR: 'solicitacao_deslocamento<>acessar',
    SOLICITACAO_DESLOCAMENTO_VISUALIZA_TRAMITACAO: 'solicitacao_deslocamento<>visualiza_tramitacao',
    SOLICITACAO_DESLOCAMENTO_RECEBER: 'solicitacao_deslocamento<>receber',
    SOLICITACAO_DESLOCAMENTO_INCLUIR: 'solicitacao_deslocamento<>incluir',
    SOLICITACAO_DESLOCAMENTO_ENVIAR: 'solicitacao_deslocamento<>enviar',
    SOLICITACAO_DESLOCAMENTO_EDITAR: 'solicitacao_deslocamento<>editar',
    SOLICITACAO_DESLOCAMENTO_CANCELAR_ENVIO: 'solicitacao_deslocamento<>cancelar_envio',
    SOLICITACAO_DESLOCAMENTO_DAR_PARECER: 'solicitacao_deslocamento<>dar_parecer',
    SOLICITACAO_DESLOCAMENTO_GERAR_DESLOCAMENTO: 'solicitacao_deslocamento<>gerar_deslocamento',

    //veiculos
    VEICULOS_ACESSAR: 'veiculos<>acessar',
    VEICULOS_INCLUIR: 'veiculos<>incluir',
    VEICULOS_EDITAR: 'veiculos<>editar',

    //cor_veiculo
    COR_VEICULO_ACESSAR: 'cor_veiculo<>acessar',
    COR_VEICULO_INCLUIR: 'cor_veiculo<>incluir',
    COR_VEICULO_EDITAR: 'cor_veiculo<>editar',

    //modelo_veiculo
    MODELO_VEICULO_ACESSAR: 'modelo_veiculo<>acessar',
    MODELO_VEICULO_INCLUIR: 'modelo_veiculo<>incluir',
    MODELO_VEICULO_EDITAR: 'modelo_veiculo<>editar',

    //marca_veiculo
    MARCA_VEICULO_ACESSAR: 'marca_veiculo<>acessar',
    MARCA_VEICULO_INCLUIR: 'marca_veiculo<>incluir',
    MARCA_VEICULO_EDITAR: 'marca_veiculo<>editar',

    //tipo_veiculo
    TIPO_VEICULO_ACESSAR: 'tipo_veiculo<>acessar',
    TIPO_VEICULO_INCLUIR: 'tipo_veiculo<>incluir',
    TIPO_VEICULO_EDITAR: 'tipo_veiculo<>editar',

    //tipo_combustivel
    TIPO_COMBUSTIVEL_ACESSAR: 'tipo_combustivel<>acessar',
    TIPO_COMBUSTIVEL_INCLUIR: 'tipo_combustivel<>incluir',
    TIPO_COMBUSTIVEL_EDITAR: 'tipo_combustivel<>editar',

    //  Modulo Frotas <----

    // ---> Modulo Estagiario/Bolsista

    //bolsas estagiario
    BOLSA_ESTAGIARIO_ACESSAR: 'bolsa_estagiario<>acessar',
    BOLSA_ESTAGIARIO_INCLUIR: 'bolsa_estagiario<>incluir',
    BOLSA_ESTAGIARIO_EDITAR: 'bolsa_estagiario<>editar',

    //candidato
    CANDIDATO_ACESSAR: 'candidato<>acessar',
    CANDIDATO_INCLUIR: 'candidato<>incluir',
    CANDIDATO_EDITAR: 'candidato<>editar',
    CANDIDATO_ASSOCIAR_REGRA: 'candidato<>associar_regra',
    CANDIDATO_EFETIVAR: 'candidato<>efetivar',

    //contrato estagiario bolsista
    CONTRATO_ESTAGIARIO_ACESSAR: 'contrato_estagiario<>acessar',
    CONTRATO_ESTAGIARIO_INCLUIR: 'contrato_estagiario<>incluir',
    CONTRATO_ESTAGIARIO_EDITAR: 'contrato_estagiario<>editar',

    //estagiario/bolsista
    ESTAGIARO_BOLSISTA_ACESSAR: 'estagiario_bolsista<>acessar',
    ESTAGIARO_BOLSISTA_INCLUIR: 'estagiario_bolsista<>incluir',
    ESTAGIARO_BOLSISTA_ENVIAR_MALA_DIRETA: 'estagiario_bolsista<>enviar_mala_direta',
    ESTAGIARO_BOLSISTA_EDITAR: 'estagiario_bolsista<>editar',
    ESTAGIARO_BOLSISTA_VISUALIZAR_DADOS: 'estagiario_bolsista<>visualizar_dados',
    ESTAGIARO_BOLSISTA_VISUALIZAR_FREQUENCIA: 'estagiario_bolsista<>visualizar_frequencia',

    //frequencia
    FREQUENCIA_ACESSAR: 'frequencia<>acessar',
    FREQUENCIA_INCLUIR: 'frequencia<>incluir',

    //historico mala direta
    HISTORICO_MALA_DIRETA_ACESSAR: 'historico_mala_direta<>acessar',

    //instituicao ensino
    INSTITUICAO_ENSINO_ACESSAR: 'instituicao_ensino<>acessar',
    INSTITUICAO_ENSINO_EDITAR: 'instituicao_ensino<>editar',
    INSTITUICAO_ENSINO_INCLUIR: 'instituicao_ensino<>incluir',

    //programa de bolsas
    PROGRAMA_BOLSA_ACESSAR: 'programa_bolsa<>acessar',
    PROGRAMA_BOLSA_INCLUIR: 'programa_bolsa<>incluir',
    PROGRAMA_BOLSA_EDITAR: 'programa_bolsa<>editar',
    PROGRAMA_BOLSA_INDICAR: 'programa_bolsa<>indicar',

    //requisitos dos programas
    REQUISITO_PROGRAMA_ACESSAR: 'requisito_programa<>acessar',
    REQUISITO_PROGRAMA_EDITAR: 'requisito_programa<>editar',
    REQUISITO_PROGRAMA_INCLUIR: 'requisito_programa<>incluir',

    //centro_ensino_organizacao
    CENTRO_ENSINO_ORGANIZACAO_ACESSAR: 'centro_ensino_organizacao<>acessar',
    CENTRO_ENSINO_ORGANIZACAO_EDITAR: 'centro_ensino_organizacao<>editar',
    CENTRO_ENSINO_ORGANIZACAO_INCLUIR: 'centro_ensino_organizacao<>incluir',

    //curso
    CURSO_ACESSAR: 'curso<>acessar',
    CURSO_EDITAR: 'curso<>editar',
    CURSO_INCLUIR: 'curso<>incluir',

    //fase
    FASE_ACESSAR: 'fase<>acessar',
    FASE_EDITAR: 'fase<>editar',
    FASE_INCLUIR: 'fase<>incluir',

    //grauInstrucao
    GRAU_INSTRUCAO_ACESSAR: 'grau_instrucao<>acessar',
    GRAU_INSTRUCAO_EDITAR: 'grau_instrucao<>editar',
    GRAU_INSTRUCAO_INCLUIR: 'grau_instrucao<>incluir',

    //motivoFalta
    MOTIVO_FALTA_ACESSAR: 'motivo_falta<>acessar',
    MOTIVO_FALTA_EDITAR: 'motivo_falta<>editar',
    MOTIVO_FALTA_INCLUIR: 'motivo_falta<>incluir',

    //programa
    PROGRAMA_ACESSAR: 'programa<>acessar',
    PROGRAMA_EDITAR: 'programa<>editar',
    PROGRAMA_INCLUIR: 'programa<>incluir',

    //regra
    REGRA_ACESSAR: 'regra<>acessar',
    REGRA_EDITAR: 'regra<>editar',
    REGRA_INCLUIR: 'regra<>incluir',

    //tipo_estagiario_bolsista
    TIPO_ESTAGIARIO_BOLSISTA_ACESSAR: 'tipo_estagiario_bolsista<>acessar',
    TIPO_ESTAGIARIO_BOLSISTA_EDITAR: 'tipo_estagiario_bolsista<>editar',
    TIPO_ESTAGIARIO_BOLSISTA_INCLUIR: 'tipo_estagiario_bolsista<>incluir',

    //manuais_roteiros_atos
    MANUAIS_ROTEIROS_ATOS_ACESSAR: 'manuais_roteiros_atos<>acessar',
    MANUAIS_ROTEIROS_ATOS_INCLUIR: 'manuais_roteiros_atos<>incluir',
    MANUAIS_ROTEIROS_ATOS_EDITAR: 'manuais_roteiros_atos<>editar',
    MANUAIS_ROTEIROS_ATOS_ATIVAR_INATIVAR: 'manuais_roteiros_atos<>ativar_inativar',

    RESPONSAVEL_DEPARTAMENTO: 'responsavel_departamento',
    ADM_MASTER: 'adm_master',

    //Modulo
    MODULO_INCLUIR: 'modulo<>incluir',
    MODULO_EDITAR: 'modulo<>editar',
    MODULO_ACESSAR: 'modulo<>acessar',

    RESPONSABILIDADE_DEPARTAMENTO_INCLUIR: 'usuario_resp_departamento<>cadastro_responsabilidade_departamento',
    RESPONSABILIDADE_DEPARTAMENTO_ACESSAR: 'usuario_resp_departamento<>acesso_responsabilidade_departamento',
    RESPONSABILIDADE_DEPARTAMENTO_EXCLUIR: 'usuario_resp_departamento<>excluir_responsablidade_departamento',

    //Alteração Natureza Despesa
    ALTERACAO_NATUREZA_DESPESA_ACESSAR: 'alteracao_natureza_despesa<>acessar',
    ALTERACAO_NATUREZA_DESPESA_ALTERAR_NATUREZA_DESPESA_BEM: 'alteracao_natureza_despesa<>alterar_natureza_despesa_bem',

    //Devolução movimentação simplificada
    DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_ACESSAR: 'devolucao_movimentacao_simplificada<>acessar',
    DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_INCLUIR: 'devolucao_movimentacao_simplificada<>incluir',
    DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_ENVIAR: 'devolucao_movimentacao_simplificada<>enviar',
    DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_APROVACAO: 'devolucao_movimentacao_simplificada<>aprovacao',
    DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_EDITAR: 'devolucao_movimentacao_simplificada<>editar',


    // Solicitacao Manutencao
    SOLICITACAO_MOVIMENTACAO_ACESSAR: 'solicitacao_manutencao_patrimonial<>acessar',
    SOLICITACAO_MOVIMENTACAO_INCLUIR: 'solicitacao_manutencao_patrimonial<>incluir',
    SOLICITACAO_MOVIMENTACAO_ENVIAR: 'solicitacao_manutencao_patrimonial<>enviar',
    SOLICITACAO_MOVIMENTACAO_EDITAR: 'solicitacao_manutencao_patrimonial<>editar',
    SOLICITACAO_MOVIMENTACAO_ACESSAR_ABA_TAREFA: 'solicitacao_manutencao_patrimonial<>acessar_aba_tarefa',

    // historico carga patrimonial
    HISTORICO_CARGA_PATRIMONIAL_ACESSAR: 'historico_carga_patrimonial<>acessar',
    HISTORICO_CARGA_PATRIMONIAL_INCLUIR: 'historico_carga_patrimonial<>incluir',
    HISTORICO_CARGA_PATRIMONIAL_EXCLUIR: 'historico_carga_patrimonial<>excluir',
    HISTORICO_CARGA_PATRIMONIAL_EDITAR: 'historico_carga_patrimonial<>editar',

    // inventário anual
    INVENTARIO_ANUAL_ACESSAR: 'inventario_anual<>acessar',
    INVENTARIO_ANUAL_INCLUIR: 'inventario_anual<>incluir',
    INVENTARIO_ANUAL_EXCLUIR: 'inventario_anual<>excluir',
    INVENTARIO_ANUAL_EDITAR: 'inventario_anual<>editar',

    // alienação ibp
    ALIENACAO_IBP_ACESSAR: 'solicitacao_alienacao_patrimonial<>acessar',
    ALIENACAO_IBP_INCLUIR: 'solicitacao_alienacao_patrimonial<>incluir',
    ALIENACAO_IBP_EXCLUIR: 'solicitacao_alienacao_patrimonial<>excluir',
    ALIENACAO_IBP_EDITAR: 'solicitacao_alienacao_patrimonial<>editar',

    // movimentacoes efetuadas
    MOVIMENTACOES_EFETUADAS_ACESSAR: 'solicitacao_alienacao_patrimonial<>acessar',

    //Inventário e Divergências
    INVENTARIO_DIVERGENCIAS_ACESSAR: 'inventario_divergencias<>acessar',
    INVENTARIO_DIVERGENCIAS_EXCLUIR_IBP: 'inventario_divergencias<>excluir',


    //Impressão de Etiquetas
    IMPRESSAO_ETIQUETA_ACESSAR: 'impressao_etiqueta<>acessar',
    IMPRESSAO_ETIQUETA_IMPRIMIR: 'impressao_etiqueta<>imprimir',
    IMPRESSAO_ETIQUETA_ALTERAR_STATUS: 'impressao_etiqueta<>alterar_status',
    IMPRESSAO_ETIQUETA_REIMPRIMIR: 'impressao_etiqueta<>reimprimir',
    IMPRESSAO_ETIQUETA_IMPRIMIR_TODOS: 'impressao_etiqueta<>imprimir_todos',

    //Migração de Dados - Planilha
    MIGRACAO_DADOS_PLANILHA_ACESSAR: 'migracao_dados_planilha<>acessar',


    //Monitoramento RFID - Antenas
    MONITORAMENTO_RFID_ANTENAS_ACESSAR: 'monitoramento_rfid_antenas<>acessar',
    MONITORAMENTO_RFID_ANTENAS_MONITORAMENTO: 'monitoramento_rfid_antenas<>monitoramento',



    //Histórico Edição Item Bem Permanente
    HISTORICO_EDICAO_IBP_ACESSAR: 'historico_edicao_ibp<>acessar',


    //Compras
    AUTORIZACAO_COMPRA_ACESSAR: 'autorizacao_compra<>acessar',
    PROCESSO_COMPRA_ACESSAR: 'processo_compra<>acessar',
    REQUISICAO_COMPRA_ACESSAR: 'requisicao_compra<>acessar',

    //Ata
    ATA_ACESSAR: 'ata<>acessar',

    //Contratos
    CONTRATO_ACESSAR: 'contrato<>acessar',

    //Gestão Financeira
    GESTAO_FINANCEIRA_ACESSAR: 'gestao_financeira<>acessar',


    EXERCICIO_FISCAL_ACESSAR: 'exercicio_fiscal<>acessar',
    EXERCICIO_FISCAL_INCLUIR: 'exercicio_fiscal<>incluir',
    EXERCICIO_FISCAL_EDITAR: 'exercicio_fiscal<>editar'


}

export default PrivilegiosEnum;